import React from 'react'
import { TableProps } from 'antd/lib/table'

import { ColumnProps } from 'src/components/Ant/Table'
import { currencyMask } from 'src/components/Formik'
import { Text } from 'src/components/Ant'

import R7HeaderTable, { R7HeaderTableGeneric } from './r7-header-table-generic'

const columns: ColumnProps<R7HeaderTableGeneric>[] = [
  {
    align: 'center',
    dataIndex: 'name',
    key: 'name',
    render: (value: string) => <Text>{value}</Text>,
    title: 'web.report.7.header.agencies.agency'
  },
  {
    align: 'center',
    dataIndex: 'total',
    key: 'total',
    render: (value: number) => (
      <Text>
        {
          currencyMask({
            formatStr: true,
            precision: 2,
            value
          }).maskedValue
        }
      </Text>
    ),
    title: 'web.report.7.header.agencies.total'
  },
  {
    align: 'center',
    dataIndex: 'percent',
    key: 'percent',
    render: (value: string) => <Text>{value}</Text>,
    title: 'web.report.7.header.agencies.percent'
  }
]

function R7HeaderTableAgencies({
  dataSource
}: TableProps<R7HeaderTableGeneric>) {
  return <R7HeaderTable columns={columns} dataSource={dataSource} />
}

export default R7HeaderTableAgencies
